import { QRFC } from "./QRFC";

export class QUploadExcelDB extends QRFC {
  constructor() {
    super();
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    //TODO: Why is this stacked?
    this.SetAllowStacked(true);
  }

  SetParams(org, user, chartID, settings) {
    this.AddEncodedParameter("chartID", chartID);
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("settings", settings);
  }

  GetCallName() {
    return "quploadexceldb";
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var success = true;
    if (r == "failure") success = false;

    callBackObj.ExcelDBResult(success, r);
  }
}
